import { root } from '../util/root';
const Symbol = root.Symbol;
export const $$rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
//# sourceMappingURL=rxSubscriber.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs-es/symbol/rxSubscriber.js
// module id = 20
// module chunks = 4